import { Component, OnInit, OnDestroy,PLATFORM_ID,Inject } from "@angular/core";
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from "@angular/router";

import { TranslateService } from "@ngx-translate/core";
import { RemoveSidenavlistService } from "../../services/remove-sidenavlist.service";
import { Subscription } from "rxjs";
import { GateTransacrionService } from "./gate-success.service";
import { SellerNameSaverService } from "../../services/seller-name-saver.service";
import {PAYMENTATTEMPT_STATUS} from 'src/app/shared/paymentStatuses'

declare let $;
@Component({
  selector: "app-success-failure",
  templateUrl: "./gate-success-failure.component.html",
  styleUrls: ["./gate-success-failure.component.scss"]
})
export class GateSuccessFailureComponent implements OnInit, OnDestroy {
  amount: number;
  status: string = "";
  providerRef:string;
  paymentPaid: boolean = true;
  subscription: Subscription;
  isCreditCard: boolean = false;
  gateMessage:string;
  showRecipt:boolean = false;
  showPleaseWait: boolean = true;
  refNum:string;
  isWallet:boolean = false;
  customerRedirectUrl: URL;
  customerRef: string;
  reason: string = "";

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public translate: TranslateService,
    private removeSidenavService: RemoveSidenavlistService,
    private gateTransacrionService: GateTransacrionService,
    public SellerNameSaver : SellerNameSaverService,
    @Inject(PLATFORM_ID) private platformID
  ) {
    this.translate.use('en');
  }

  async ngOnInit() {
    if (isPlatformBrowser(this.platformID)) {
      if (!this.SellerNameSaver.pattern)
        this.SellerNameSaver.pattern = JSON.parse(localStorage.getItem('code'));
      this.subscription = this.route.queryParams.subscribe(async (data) => {
        this.status = data.reason;
        this.gateMessage = data.message;
        this.refNum = data.merchant_order_id
        ? data.merchant_order_id
        : data.refNum;
        this.isCreditCard = !!data.card;
        this.isWallet = data.isWallet;
        this.gateTransacrionService.setParams({
          refNum: this.refNum,
          isWallet: this.isWallet
        });
        const result = await this.gateTransacrionService.make();
        this.status = result?.status;
        if (result.status === PAYMENTATTEMPT_STATUS.PAID) {
          this.paymentPaid = true;
          this.showPleaseWait = false;
          const vpihs = JSON.parse(localStorage.getItem("vpihs"))
          this.showRecipt = !!vpihs;
        } else {
          this.paymentPaid = false;
          this.showPleaseWait = false;
          this.showRecipt = false;
          if (result?.PAreason) this.reason = result.PAreason;
        }
        try {
          if (result?.directPayRedirectUrl) {
            this.customerRedirectUrl = new URL(
              result.directPayRedirectUrl
            );
            this.customerRef = result.directPayCustomerRef;
            this.onContinueClick();
          }
        } catch (error) {
          console.log('🚀 ~ this.customerRedirectUrl error', error);
        }
      });

      this.removeSidenavService.emitSidenavO(false);

      localStorage.removeItem('customerRedirectUrl');

      $(document).ready(function () {
        let whe = $(window).height();
        let hehe = $('.header').height();
        let fohe = $('.ekfe-footer').height();
        $('.main').css('min-height', whe - hehe - fohe - 50 - 36 - 120);
      });

      $(window).resize(function () {
        let whe = $(window).height();
        let hehe = $('.header').height();
        let fohe = $('.ekfe-footer').height();
        $('.main').css('min-height', whe - hehe - fohe - 50 - 36 - 120);
      });

      $('.bur-button').on('click', function () {
        $('.header-login-hide').slideToggle(500);
      });

      $(document).ready(function () {
        let p = $('.image-block').height();
        $('.business-over').css('top', p);
      });

      $(window).resize(function () {
        let p = $('.image-block').height();
        $('.business-over').css('top', p);
      });
    }
  }

  onContinueClick() {
    if (this.customerRedirectUrl) {
      this.customerRedirectUrl.searchParams.set('status', this.status);
      this.customerRedirectUrl.searchParams.set('providerRefNum', this.refNum);
      this.customerRedirectUrl.searchParams.set('customerReference', this.customerRef);
      window.location.href = this.customerRedirectUrl.toString();
    } else if (this.SellerNameSaver.pattern) {
      this.router.navigate(['/', this.SellerNameSaver.pattern]);
    } else {
      this.router.navigate(['/']);
    }
  }

  ngOnDestroy() {
    this.removeSidenavService.emitSidenavO(true);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
